/**
 * @file MovementsCards.tsx
 * @description Журнал движений карточками на `<lg` (phase19.24 этап 1, шаг 2).
 *
 * До контракта журнал на 360px был той же таблицей с горизонтальным скроллом:
 * кладовщик листал вправо, чтобы увидеть количество. Теперь строка — общий
 * `DocumentCard`: название и количество в шапке, артикул моно, остальное —
 * строками метаданных в порядке «что сделали · где · какая партия · чем
 * обосновано · когда».
 */

import { DocumentCard } from "../../ui/DocumentCard";
import { MovementBasis, MovementLot, MovementQuantity } from "./MovementCells";
import { movementOperationText } from "../../../lib/movements-texts";
import { formatSkuName, type StockMovementDto } from "../../../lib/api-wms";

interface Props {
  items: StockMovementDto[];
  /** Slug магазина — нужен ссылкам на документы-основания. */
  slug?: string;
}

/** Короткая дата для карточки: «03.09, 10:12» (год виден в периоде фильтра). */
function formatShortMoment(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function MovementsCards({ items, slug }: Props) {
  return (
    <ul className="flex flex-col gap-2 lg:hidden">
      {items.map((movement) => (
        <li key={movement.id}>
          <DocumentCard
            title={formatSkuName(movement.sku)}
            code={movement.skuCode}
            qty={<MovementQuantity quantity={movement.quantity} />}
            meta={[
              `${movementOperationText(movement)} · ${movement.warehouse?.name ?? "склад не указан"}`,
              movement.lot ? (
                <span key="lot">
                  партия <MovementLot movement={movement} />
                </span>
              ) : (
                "без партии"
              ),
              // Ссылка на документ — кнопкой-строкой вместе с подписью
              // «Основание:»: тач-цель 48px (56 у кладовщика), а не 17px
              // номера (приёмка qa4 п. 6); пояснение — линией под ней.
              <MovementBasis key="basis" movement={movement} slug={slug} fit="row" />,
              formatShortMoment(movement.createdAt),
            ]}
          />
        </li>
      ))}
    </ul>
  );
}
